export enum UserType {
  CUSTOMER,
  MERCHANT_USER,
  NOT_SPECIFIED,
  ADMIN,
  PAYMENT_INTEGRATION,
  GIFT_CARD_INTEGRATION
}
export class UserRegistrationDto {
  firstName?: string;
  lastName?: string;
  email?: string;
  password?: string;
  type?: UserType = UserType.NOT_SPECIFIED;
  merchantIds?: number[];
  roleId?: string;
  profile?: any;
}
